import React, { useEffect } from 'react';
import Post from './Pages/Post/Post';
import { CssBaseline, Container, Grid, Typography } from '@mui/material';
import { BrowserRouter as Router, useNavigate } from 'react-router-dom';
import MainLayout from './Layouts/MainLayout';
import AppRoutes from './routes/AppRoutes';
import NetworkStatusNotifier from './services/NetworkStatusNotifier';
import NotificationStack from './Components/NotificationStack';
import { LoadScript } from '@react-google-maps/api';
import axios from 'axios';
import useFirebaseMessaging from './hooks/useFirebaseMessaging';
import { requestFirebaseNotificationPermission } from './services/firebaseMessaging';
import { navigationService } from './services/navigationService';

// Inner component to access useNavigate hook
const AppContent: React.FC = () => {
  const navigate = useNavigate();
  
  // Initialize navigation service
  useEffect(() => {
    navigationService.setNavigate(navigate);
  }, [navigate]);

  // Initialise Firebase Cloud Messaging when user is logged-in
  useFirebaseMessaging();

  axios.get("https://api.ipify.org/?format=json").then((res: any) => {
    console.log("ip----------------------------------------",res.data);
  });
  // get the ip address of the user (v4 address)
  
  useEffect(() => {


    const registerFcmToken = async () => {
      if (!('serviceWorker' in navigator)) return;
      try {
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        const token = await requestFirebaseNotificationPermission(registration);
        if (token) {
          console.log("token every time",token);
        }
      } catch (err) {
        console.error('[FCM] Failed to generate FCM token', err);
      }
    };
    registerFcmToken();
  }, []);
  



  return (
    <MainLayout>
      <NetworkStatusNotifier />
      <NotificationStack />
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_KEY || ""}
        libraries={["places", "geometry"]}
      >
        <AppRoutes />
      </LoadScript>
    </MainLayout>
  );
};

const App: React.FC = () => {
  return (
    <Grid 
      container 
      spacing={0.5} 
      columns={12}
      sx={{
        minWidth: '320px', // Minimum width to prevent breaking on very small screens
        width: '100%',
        maxWidth: '100vw',
        overflow: 'hidden' // Prevent horizontal scrolling
      }}
    >
      {/* left gutter: hidden on xs, 2 cols on sm, 3 cols on md+ */}
      <Grid
        
        size={{ sm: 2, md: 4 }}
        sx={{ 
          display: { xs: "none", sm: "block" }, 
          // backgroundColor: "red",
          minWidth: { sm: 'auto' } // Ensure proper sizing on small screens
        }}
      />
      {/* main content: full width on xs, 8 cols on sm, 6 cols on md */}
      <Grid 
        size={{ xs: 12, sm: 8, md: 4 }} 
        sx={{ 
          backgroundColor: "#f9f9f9",
          minWidth: { xs: '280px', sm: 'auto' }, // Minimum width for content area
          width: '100%',
          maxWidth: '100%'
        }}
      >
        <Router>
          <AppContent />
        </Router>
      </Grid>

      {/* right gutter: mirror of left */}
      <Grid
        
        size={{ sm: 2, md: 4 }}
        sx={{ 
          display: { xs: "none", sm: "block" }, 
          // backgroundColor: "red",
          minWidth: { sm: 'auto' } // Ensure proper sizing on small screens
        }}
      />
    </Grid>
  );
}

export default App;
